import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var LinkedinOutline = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("g", {
    "data-name": "Layer 2",
    key: "k0"
  }, React.createElement("g", {
    "data-name": "linkedin"
  }, React.createElement("path", {
    d: "M20 22h-1.67a2 2 0 01-2-2v-5.37a.92.92 0 00-.69-.93.84.84 0 00-.67.19.85.85 0 00-.3.65V20a2 2 0 01-2 2H11a2 2 0 01-2-2v-5.46a6.5 6.5 0 1113 0V20a2 2 0 01-2 2zm-4.5-10.31a3.73 3.73 0 01.47 0 2.91 2.91 0 012.36 2.9V20H20v-5.46a4.5 4.5 0 10-9 0V20h1.67v-5.46a2.85 2.85 0 012.83-2.85zM6 22H4a2 2 0 01-2-2V10a2 2 0 012-2h2a2 2 0 012 2v10a2 2 0 01-2 2zM4 10v10h2V10zM5 7a3 3 0 113-3 3 3 0 01-3 3zm0-4a1 1 0 101 1 1 1 0 00-1-1z"
  }))));
});
LinkedinOutline.displayName = 'LinkedinOutline';
export var LinkedinOutlineDimensions = {
  height: 20,
  width: 20
};